
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-kassierer-data-view',
  imports: [],
  templateUrl: './kassierer.list-view.html',
  styleUrls: ['./kassierer.list-view.css'],
})
export class KassiererListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();

  constructor() {
    //
  }
}
